import { render, staticRenderFns } from "./portfolio-benchmark.vue?vue&type=template&id=40676167&"
import script from "./portfolio-benchmark.vue?vue&type=script&lang=js&"
export * from "./portfolio-benchmark.vue?vue&type=script&lang=js&"
import style0 from "./portfolio-benchmark.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40676167')) {
      api.createRecord('40676167', component.options)
    } else {
      api.reload('40676167', component.options)
    }
    module.hot.accept("./portfolio-benchmark.vue?vue&type=template&id=40676167&", function () {
      api.rerender('40676167', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/portfolio-benchmark/portfolio-benchmark.vue"
export default component.exports